module.exports = __webpack_public_path__ + "img/passo_04.7aaef96a.png";